import { render, staticRenderFns } from "./UserInterface.vue?vue&type=template&id=e349d624&scoped=true"
import script from "./UserInterface.vue?vue&type=script&lang=js"
export * from "./UserInterface.vue?vue&type=script&lang=js"
import style0 from "./UserInterface.vue?vue&type=style&index=0&id=e349d624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e349d624",
  null
  
)

export default component.exports